import { Select, SelectItem } from "@aidron/aidron-ds";

import { Wrapper } from "./HierarchyGroupFilter.style";

import { CustomText } from "../../StyledComponents/styleComponents.index";

import PropTypes from 'prop-types';

export function HierarchyGroupFilter({ actions, ctx }) {

  const { onChange, setGroupingName } = actions || {};

  const { 
    label,
    selected = 1,
    direction = "",
    groupInformationData = []
  } = ctx || {};

  return (
    <Wrapper direction={direction}>
      <CustomText fontSize={['0.4rem', '0.6rem', '1rem']} weight="bold" margin={direction === "column" ? "" : "0 1rem 0 0"}>
        {label}
      </CustomText>
      
      <Select 
        readOnly 
        label="" 
        selected={selected} 
        handleChange={(value) => {
          const option = groupInformationData.find(opt => opt.value === value);
          
          if (onChange) onChange(value);
          if (setGroupingName) setGroupingName(option?.groupDisplayName ?? "Empresa");
        }}>
        {groupInformationData.map(option => (
          <SelectItem value={option.value} key={option.value}>
            {option.groupDisplayName ?? "Empresa" }
          </SelectItem>
        ))}
      </Select>
    </Wrapper>
  );
}

HierarchyGroupFilter.propTypes = {
  actions: PropTypes.shape(),
  ctx: PropTypes.shape()
}